/**
* Components are lazy-loaded - See "Grouping Components in the Same Chunk"
* http://router.vuejs.org/en/advanced/lazy-loading.html
*/
/* eslint-disable global-require */

const campaigns = r => require.ensure([], () => r(require('./components/index')), 'campaigns');

const previewScenario = r => require.ensure([], () => r(require('./components/previewScenario')), 'preview');

const bulk_campaign_preview = r => require.ensure([], () => r(require('./components/bulk_campaign_preview')), 'campaigns');

const bulk_campaign_preview_edit = r => require.ensure([], () => r(require('./components/bulk_campaign_preview_edit')), 'campaigns');


const manageCampaign = {

    create:      r => require.ensure([], () => r(require('./components/create')),           'manage-campaign'),
   
};

export default [
    {
        name: 'bulk_campaigns',
        path: '/bulk/campaigns',
        // alias: '/announcements',
        component: campaigns,
        
    },  
    {
        name: 'bulk_campaigns.schedule',
        path: '/bulk/campains/schedule/:id',
        
        // alias: '/announcements/create',
        component: manageCampaign.create,
        // redirect: { name: 'campaigns.create' },
        
    },  
    {
        name: 'previewScenario',
        path: '/previewScenario/:id',
        component: previewScenario
    },
    {
        name: 'bulkcampaign_preview',
        path: '/bulk_campaign/preview/:id',
        component: bulk_campaign_preview,
    },
    {
        name: 'bulkcampaign_preview_edit',
        path: '/bulk_campaign/preview/edit/:id',
        component: bulk_campaign_preview_edit,
    },
]







// WEBPACK FOOTER //
// ./src/app/bulk_campaign/routes.js